import { apiSlice } from './apiSlice';

export const paypalStandardApi = apiSlice.injectEndpoints({ endpoints: builder => ({
  getPaypalStandardConfig: builder.query({ query: () => '/api/paypal-standard/config' }),
  createPaypalStandardOrder: builder.mutation({ query: id => ({ url: `/api/paypal-standard/orders/${id}`, method: 'POST' }) }),
  capturePaypalStandardOrder: builder.mutation({ query: ({ id, paypalOrderId }) => ({ url: `/api/paypal-standard/orders/${id}/capture`, method: 'POST', body: { paypalOrderId } }), invalidatesTags: ['Order'] }),
  refreshPaypalStandardOrder: builder.mutation({ query: id => ({ url: `/api/paypal-standard/orders/${id}/refresh`, method: 'POST' }), invalidatesTags: ['Order'] }),
}) });
export const { useGetPaypalStandardConfigQuery,  
   useCreatePaypalStandardOrderMutation, useCapturePaypalStandardOrderMutation,
  useRefreshPaypalStandardOrderMutation } = paypalStandardApi;
